import Form from './Form';
export default Form;
//# sourceMappingURL=index.js.map